import SearchForm from './Search.svelte';

export { default as debounce } from '@/modules-es5/commons/lib/lib-debounce';

export const init = () => {
  // get search trendings
  const jsonTrends = cube.$id('internalSearchTrendsJson');
  const trends = jsonTrends ? JSON.parse(jsonTrends.innerHTML) : [];
  // init Search component
  return new SearchForm({
    target: cube.$('.l-search-form'),
    props: { params: cube.$('.l-search-form').dataset, trends },
    hydrate: true,
  });
};

/**
 * Giving a search term, look for results with the seach API
 * Returns : { pages, productsList }
 *
 * Promise based function -- then / catch or async / await
 *
 * TODO : Move this in the (future) src/commons/api/search.js -- See cube-front-core #240
 *        https://git.cube-net.org/cube-front/cube-front-core/merge_requests/240
 *
 * @param {String} term Look for this term in the search API
 */
export function getSearchTerm(term, searchParams) {
  return new Promise((resolve, reject) => {
    // get search params (from <form> element)
    const { content, wildcards, minLength, maxLength } = searchParams;
    // build URL
    let url = `getAutoComplete?query=${term}`;
    if (minLength) url += `&minLength=${minLength}`;
    if (maxLength) url += `&maxLength=${maxLength}`;
    if (wildcards) url += `&type=1&wildcards=${wildcards}`;
    if (content) url += `&contentCollection=${encodeURIComponent(content)}`;
    // call URL & resolve promise
    cube.ajax
      .get(url)
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Highlight some words inside a string
 * - HTML output : highlighted text wrapped inside 'span.highlight'
 *
 * @param {String} words  list of words to hightlight, separated by a space
 * @param {String} string String in witch words will be hightlighted
 * @param {String} highlight Class used to highlight words. Default is highlight
 */
export const highlightWords = (words, string, highlight = 'highlight') => {
  let regex = '';

  // eslint-disable-next-line no-restricted-syntax
  for (const word of words.split(' ')) {
    // if word contains only letters, we add it to the regex
    if (new RegExp('\\w+').test(word)) regex += `${word}|`;
  }

  regex = regex.slice(0, -1); // remove last pipe from regex

  // We replace all mathing words
  return string.replace(
    new RegExp(regex, 'gi'),
    match => `<span class="${highlight}">${match}</span>`
  );
};



// WEBPACK FOOTER //
// ./src/commons/header/search/search.js